/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Pnb_TitleInputs */

const es_marketplace_seo_license_row_pnb_title = /** @type {(inputs: Marketplace_Seo_License_Row_Pnb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNB`)
};

const gl_marketplace_seo_license_row_pnb_title = /** @type {(inputs: Marketplace_Seo_License_Row_Pnb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNB`)
};

const en_marketplace_seo_license_row_pnb_title = /** @type {(inputs: Marketplace_Seo_License_Row_Pnb_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PNB`)
};

/**
* | output |
* | --- |
* | "PNB" |
*
* @param {Marketplace_Seo_License_Row_Pnb_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_pnb_title = /** @type {((inputs?: Marketplace_Seo_License_Row_Pnb_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Pnb_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_pnb_title(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_pnb_title(inputs)
	return es_marketplace_seo_license_row_pnb_title(inputs)
});